import axios from "@/lib/axios";
import { SpringPage, SpringPageableRequest } from "@/types/apis";
import {
  DimensionId,
  QuestionnaireResultStatus,
  QuizStatus,
} from "@/types/questionnaries";

export type PreviousEditionsRequestParams = SpringPageableRequest & {
  companyId: string;
  editionName?: string;
  resultStatus?: QuestionnaireResultStatus;
};

export type PreviousEditionsResponseContent = {
  id: string;
  quizStatus: QuizStatus;
  edition: {
    id: string;
    name: string;
    year: number;
  };
  result: {
    resultStatus: QuestionnaireResultStatus;
    score: number;
    scoreProportion: number;
  };
  dimensionsScores: {
    dimension: DimensionId;
    score: number;
    scoreProportion: number;
  }[];
};

export type PreviousEditionsResponse =
  SpringPage<PreviousEditionsResponseContent>;

export const getPreviousEditions = (params: PreviousEditionsRequestParams) =>
  axios
    .get<PreviousEditionsResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/previous-editions`,
      {
        params,
      },
    )
    .then((res) => res.data);
